module.exports = __webpack_public_path__ + "static/media/Pic4.c64382fe.png";